/**
 * @generated SignedSource<<7b367ba8bd3b5576f3dff5dbe29d501a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceTodoDetailScreenArchiveMutation$variables = {
  todoWorkspaceId: string;
};
export type WorkspaceTodoDetailScreenArchiveMutation$data = {
  readonly todoWorkspace: {
    readonly archive: {
      readonly archivedAtDate: {
        readonly " $fragmentSpreads": FragmentRefs<"FormattedDate">;
      } | null;
      readonly id: string;
    };
  };
};
export type WorkspaceTodoDetailScreenArchiveMutation = {
  response: WorkspaceTodoDetailScreenArchiveMutation$data;
  variables: WorkspaceTodoDetailScreenArchiveMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "todoWorkspaceId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "todoWorkspaceId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspaceTodoDetailScreenArchiveMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TodoWorkspaceMutation",
        "kind": "LinkedField",
        "name": "todoWorkspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TodoWorkspace",
            "kind": "LinkedField",
            "name": "archive",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UnzonedDate",
                "kind": "LinkedField",
                "name": "archivedAtDate",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "FormattedDate"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WorkspaceTodoDetailScreenArchiveMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TodoWorkspaceMutation",
        "kind": "LinkedField",
        "name": "todoWorkspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TodoWorkspace",
            "kind": "LinkedField",
            "name": "archive",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UnzonedDate",
                "kind": "LinkedField",
                "name": "archivedAtDate",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isoString",
                        "storageKey": null
                      }
                    ],
                    "type": "Date",
                    "abstractKey": "__isDate"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1edab6ae9dcb430dd23f652473a7d7bb",
    "id": null,
    "metadata": {},
    "name": "WorkspaceTodoDetailScreenArchiveMutation",
    "operationKind": "mutation",
    "text": "mutation WorkspaceTodoDetailScreenArchiveMutation(\n  $todoWorkspaceId: ID!\n) {\n  todoWorkspace(id: $todoWorkspaceId) {\n    archive {\n      id\n      archivedAtDate {\n        ...FormattedDate\n      }\n    }\n  }\n}\n\nfragment FormattedDate on Date {\n  __isDate: __typename\n  ...useFormattedDate\n}\n\nfragment useFormattedDate on Date {\n  __isDate: __typename\n  isoString\n}\n"
  }
};
})();

(node as any).hash = "eac25252e9701b6c13e6651045971d54";

export default node;
